import { render } from "./Webapp.vue?vue&type=template&id=167b3feb&scoped=true"
import script from "./Webapp.vue?vue&type=script&lang=js"
export * from "./Webapp.vue?vue&type=script&lang=js"

import "./Webapp.vue?vue&type=style&index=0&id=167b3feb&scoped=true&lang=css"
import "./Webapp.vue?vue&type=style&index=1&id=167b3feb&scoped=true&lang=css"
import "./Webapp.vue?vue&type=style&index=2&id=167b3feb&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167b3feb"]])

export default __exports__